import { useState } from 'react';
import { useCreateQueue, useUpdateQueue, useSelectedPlant } from '../../../../hooks';

import { SetupDrawer } from '../../../atoms';
import { TextInput } from '@pella/sash-framework';

/**
 * Component for the Queue Drawer.
 * @param {Local.SetupDrawerProps} props - Component props
 */
export const QueueDrawer = ({ open, close, data, selectedId }) => {
  const { selectedPlant } = useSelectedPlant();
  const { mutate: createQueue, isPending: isCreating } = useCreateQueue();
  const { mutate: updateQueue, isPending: isUpdating } = useUpdateQueue();

  const [formChanges, setFormChanges] = useState(
    /** @type {Partial<Pella.ProductionRequestAPI.CreateQueueInput>} */ ({}),
  );

  const currentForm = selectedId ? data?.find((record) => record.id === selectedId) : { active: true };

  // Combine initial data with form changes to get the current queue state
  const queue = { ...currentForm, ...formChanges };
  const isEdit = Boolean(selectedId);

  /** Handler to reset form and close drawer */
  const handleClose = () => {
    setFormChanges({});
    close();
  };

  /** handler for form submission */
  const handleSubmit = () => {
    // Ensure all required fields are defined before mutation
    if (!isEdit) {
      const input = {
        plantId: selectedPlant,
        /* v8 ignore start */
        active: queue.active ?? true,
        description: queue.description || '',
        /* v8 ignore stop */
      };
      createQueue(input, { onSuccess: handleClose });
    } else {
      const id = selectedId;
      const input = {
        description: queue.description,
        active: queue.active,
      };
      updateQueue({ id, input }, { onSuccess: handleClose });
    }
  };

  const hasRequiredFields = Boolean(queue.description?.trim());
  const isLoading = isCreating || isUpdating;

  const disableSubmit = !hasRequiredFields || isLoading;
  const disableForms = !queue.active;
  return (
    <SetupDrawer
      open={open}
      close={handleClose}
      title='Queue'
      isEdit={isEdit}
      isCopy={false}
      active={Boolean(queue.active)}
      onActiveChange={() => setFormChanges((prev) => ({ ...prev, active: !queue.active }))}
      onSubmit={handleSubmit}
      disableSubmit={disableSubmit}
    >
      <TextInput
        id='queueNameInput'
        labelText='Queue Name'
        disabled={disableForms}
        maxLength={50}
        required={Boolean(!queue.description)}
        value={queue.description || ''}
        onChange={(e) => setFormChanges((prev) => ({ ...prev, description: e.target.value }))}
      />
    </SetupDrawer>
  );
};
